import { render } from "./PointGroup.vue?vue&type=template&id=6967d3c3&scoped=true"
import script from "./PointGroup.vue?vue&type=script&lang=js"
export * from "./PointGroup.vue?vue&type=script&lang=js"

import "./PointGroup.vue?vue&type=style&index=0&id=6967d3c3&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6967d3c3"]])

export default __exports__